/** @jsxImportSource @emotion/react */

import { Tabs, TabsProps } from "antd";
import { TimeFilter } from "enums/transaction";
import { useAppDispatch } from "hooks/app-hook";
import { useSelector } from "react-redux";
import { selectOrdersFilter, updateOrdersFilter } from "store/orders";

import { FilterTimeTabsStyle } from "./style.index";

const FilterTimeTabs = () => {
  const dispatch = useAppDispatch();
  const filterValue = useSelector(selectOrdersFilter);

  const items: TabsProps["items"] = [
    {
      key: TimeFilter.TODAY,
      label: `Hôm nay`,
      children: ``,
    },
    {
      key: TimeFilter.YESTERDAY,
      label: `Hôm qua`,
      children: ``,
    },
    {
      key: TimeFilter.THIS_WEEK,
      label: `Trong vòng 7 ngày`,
      children: ``,
    },
    {
      key: TimeFilter.THIS_MONTH,
      label: `Trong vòng 30 ngày`,
      children: ``,
    },
  ];

  return (
    <div css={FilterTimeTabsStyle.wrapper}>
      <Tabs
        defaultActiveKey={TimeFilter.TODAY}
        activeKey={filterValue}
        items={items}
        onChange={(value) => dispatch(updateOrdersFilter(value as TimeFilter))}
      />
    </div>
  );
};

export default FilterTimeTabs;
